module.exports = __webpack_public_path__ + "img/smiley_neutral_ico.58b60250.png";